/* eslint-disable @typescript-eslint/consistent-type-assertions */
import React from 'react';
import type { EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import {
	TEAM_MANAGED_PROJECT,
	type JiraProjectStyle,
} from '@jira/platform__project-types/src/project-types.tsx';
import SubspaceMenuListQuery from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-subspaces/src/SubspaceMenuListQuery.tsx';
import type { SubspaceMenuListQuery as SubspaceMenuListQueryType } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-subspaces/src/__generated__/SubspaceMenuListQuery.graphql';
import JswExpandableProjectRefactoredQuery from './JswExpandableProjectRefactoredQuery.tsx';
import type { JswExpandableProjectRefactoredQuery as JswExpandableProjectRefactoredQueryType } from './__generated__/JswExpandableProjectRefactoredQuery.graphql';

type Queries = { projects: JswExpandableProjectRefactoredQueryType | SubspaceMenuListQueryType };

type JswExpandableProjectSubspaceQueryProps = {
	projectStyle?: JiraProjectStyle | null;
};

export default function JswExpandableProjectSubspaceQuery({
	extraProps,
	...props
}: EntryPointProps<Queries, {}, EntryPointRouteParams, JswExpandableProjectSubspaceQueryProps>) {
	const { projectStyle } = extraProps;

	if (projectStyle === TEAM_MANAGED_PROJECT) {
		return (
			<SubspaceMenuListQuery
				{...(props as EntryPointProps<
					{ projects: SubspaceMenuListQueryType },
					{},
					EntryPointRouteParams,
					{}
				>)}
			/>
		);
	}

	// NOTE: we may need to move this into SubspaceMenuListQuery if we want to mix the boards and subspaces items for CMP
	return (
		<JswExpandableProjectRefactoredQuery
			{...(props as EntryPointProps<
				{ projects: JswExpandableProjectRefactoredQueryType },
				{},
				EntryPointRouteParams,
				{}
			>)}
		/>
	);
}
